import React, { useEffect, useState } from 'react';
import DGSH_gyv_mrp_order_list from '../components/DGSH/DGSH_gyv_mrp_order_list';
import DGSH_row_open from '../components/DGSH/DGSH_row_open';
import DGSH_pdc from '../components/DGSH/DGSH_pdc';
import DGSH_customer_ddt from '../components/DGSH/DGSH_customer_ddt';
import DGSH_customer_invoices from '../components/DGSH/DGSH_customer_invoices';
import DGSH_customer_transport_document from '../components/DGSH/DGSH_customer_transport_document';
import DGSH_order_available from '../components/DGSH/DGSH_order_available';
import DGSH_customer_order from '../components/DGSH/DGSH_customer_order';
import DGSH_item_model from '../components/DGSH/DGSH_item_model';




export default function DataGridSelectionHook({ data, setData, entity = null, selectedRows, setSelectedRows, refreshData }) {


    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'test': return (
                            <span>Test</span>
                        );
                        case 'gyv_mrp_order_list': return (
                            <DGSH_gyv_mrp_order_list data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData}/>
                        );
                        case 'gyv_open_customer_rows': return (
                            <DGSH_row_open data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData} entity={entity}></DGSH_row_open> 
                        );
                        case 'gyv_pdc': return (
                            <DGSH_pdc data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData} entity={entity}></DGSH_pdc> 
                        );
                        case 'customer_ddt': return (
                            <DGSH_customer_ddt data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData}></DGSH_customer_ddt> 
                        );
                        case 'customer_invoices': return (
                            <DGSH_customer_invoices data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData}></DGSH_customer_invoices> 
                        );
                        case 'customer_transport_document': return (
                            <DGSH_customer_transport_document data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData}></DGSH_customer_transport_document> 
                        );
                        case 'customer_order': return (
                            <DGSH_customer_order data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData}></DGSH_customer_order> 
                        );
                        case 'item_model': return (
                            <DGSH_item_model data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData}/>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};